import axios from "axios";
import serverConfig from "@/store/server";

const HEARTBEAT_INTERVAL = 30000;

let heartbeatTimer = null;
let isHeartbeatActive = false;

export function startHeartbeat(onSessionExpired) {
  if (isHeartbeatActive) {
    return;
  }

  isHeartbeatActive = true;

  const checkToken = async () => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        stopHeartbeat();
        onSessionExpired();
        return;
      }

      const url = serverConfig.url + serverConfig.urls.tokenIsValid;

      await axios.get(url, {
        headers: serverConfig.getHeader(),
      });
    } catch (error) {
      if (
        error.response &&
        (error.response.status === 401 ||
          error.response.data?.data?.code === 4.1)
      ) {
        stopHeartbeat();
        onSessionExpired();
      }
    }
  };

  checkToken();

  heartbeatTimer = setInterval(checkToken, HEARTBEAT_INTERVAL);
}

export function stopHeartbeat() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer);
    heartbeatTimer = null;
  }
  isHeartbeatActive = false;
}

